import { redirectRoute } from '../helpers';
import { WidgetAuthPages } from '../../constants/AppConstants';
import WidgetAuthActions from '../../actions/WidgetAuthActions';

module.exports = {
    path: '/widget-auth',

    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/widgetAuth/Handler').default);
        }, 'widget-auth-handler');
    },

    indexRoute: redirectRoute(null, WidgetAuthPages.LOGIN),

    getChildRoutes(location, cb) {
        require.ensure([], (require) => {
            cb(null, [
                require('./Login'),
                require('./Logout'),
                require('./Register')
            ].filter((x) => !!x));
        }, 'widget-auth-routes');
    },

    onEnter () {
        WidgetAuthActions.startSession();
    }
};



// WEBPACK FOOTER //
// ./src/routes/WidgetAuth/index.js